import React from 'react';

interface TextInputProps {
    label: string;
    name: string;
    subLabel?: string;
    placeholder?: string;
    error?: boolean;
    errorMessage?: string;
    required?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    value?: string;
}

const TextInput: React.FC<TextInputProps> = ({
                                                 label,
                                                 name,
                                                 subLabel,
                                                 placeholder,
                                                 error = false,
                                                 errorMessage,
                                                 required = false,
                                                 onChange,
                                                 value,
                                             }) => {
    return (
        <div className="form-field">
            {label && <label className={required ? 'required-field' : ''}>{label}</label>}
            {subLabel && <div className="sub-label">{subLabel}</div>}

            <input
                className={`text-input ${error ? 'error-border' : ''}`}
                type="text"
                name={name}
                placeholder={placeholder}
                onChange={onChange}
                value={value}
            />
            {error && errorMessage && <div className="error-message">{errorMessage}</div>}
        </div>
    );
};

export default TextInput;